"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNewArrivalsProductsBySearch = exports.getFBTProductsBySearch = exports.getEssentialProductsBySearch = exports.getCommonProductCarouselApiBySearch = exports.getBestSellerProductsBySearch = void 0;
exports.getProductByFilter = getProductByFilter;
exports.getProductDetails = getProductDetails;
exports.getProductDetailsPDP = getProductDetailsPDP;
exports.getProductDetailsWeb = getProductDetailsWeb;
exports.getProductDetailsWebUrlKey = getProductDetailsWebUrlKey;
exports.getProductDetailsWebUrlKeyOnly = getProductDetailsWebUrlKeyOnly;
exports.getProductFilter = void 0;
exports.getProductPromotionRules = getProductPromotionRules;
exports.getProductRichMediaContent = getProductRichMediaContent;
exports.getREProductsForCarousel = exports.getQuickFilter = exports.getProductsFromCommonCarousel = exports.getProductsBySearch = exports.getProductsByCategory = exports.getProductsByBrand = exports.getProductsByAutoSuggest = void 0;
exports.getRecommendedProducts = getRecommendedProducts;
exports.hitNotifyDownloadAppLinkAPI = exports.hitNotifyAPI = exports.getTrendingProductsBySearch = void 0;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function getProductDetails(params, tokenData) {
  const zone = {
    zone: params === null || params === void 0 ? void 0 : params.zoneIdList
  };
  const query = (0, _utils.getQuery)(zone);
  const apiEndPoint = _ApiConst.API_MYASTER_URL + _ApiConst.PRODUCT_DETAILS + (params === null || params === void 0 ? void 0 : params.sku) + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getProductDetailsPDP(params, tokenData) {
  const query = (0, _utils.getQuery)({
    zone: encodeURIComponent(params.zoneIdList.replaceAll(/\s/g, ''))
  });
  const apiEndPoint = _ApiConst.API_MYASTER_URL + _ApiConst.PRODUCT_DETAILS_PDP + params.sku + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getProductDetailsWeb(requestParams, tokenData) {
  let queryString = '';
  for (const key in requestParams) {
    if (queryString === '') {
      queryString = '?';
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.PRODUCT_DETAILS + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getProductDetailsWebUrlKey(urlKey, categoryId, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.PRODUCT_DETAILS_URL_KEY + `?urlKey=${urlKey}&categoryId=${categoryId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getProductDetailsWebUrlKeyOnly(urlKey, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.PRODUCT_DETAILS_URL_KEY + `?urlKey=${urlKey}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getRecommendedProducts(params, tokenData) {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.RECOMMENDED_PRODUCTS + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getProductByFilter(params, tokenData) {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.PRODUCT_BY_FILTER + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
const getQuickFilter = (params, tokenData) => {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.QUICK_FILTER + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
};
exports.getQuickFilter = getQuickFilter;
const getProductFilter = (params, tokenData) => {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.PRODUCT_FILTER + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
};
exports.getProductFilter = getProductFilter;
const getProductsBySearch = (params, tokenData) => {
  const apiEndPoint = (0, _utils.buildUrl)(_ApiConst.PRODUCTS_BY_SEARCH, params);
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
};
exports.getProductsBySearch = getProductsBySearch;
const getProductsByCategory = (params, tokenData) => {
  const id = params === null || params === void 0 ? void 0 : params.id;
  const formUrl = _ApiConst.PRODUCTS_BY_CATEGORY + '/' + id;
  const apiEndPoint = (0, _utils.buildUrl)(formUrl, params === null || params === void 0 ? void 0 : params.query);
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
};
exports.getProductsByCategory = getProductsByCategory;
const getProductsByBrand = (params, tokenData) => {
  const id = params === null || params === void 0 ? void 0 : params.id;
  const formUrl = _ApiConst.PRODUCTS_BY_BRAND + '/' + id;
  const apiEndPoint = (0, _utils.buildUrl)(formUrl, params === null || params === void 0 ? void 0 : params.query);
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
};
exports.getProductsByBrand = getProductsByBrand;
function getProductRichMediaContent(requestParams, tokenData) {
  const query = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.PRODUCT_RICH_MEDIA_CONTENT + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getProductPromotionRules(requestParams, tokenData) {
  const query = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.PRODUCT_PROMOTION_RULES + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
const getProductsByAutoSuggest = (params, tokenData) => {
  // console.log('===api file start', Date.now());
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.GET_PRODUCTS_BY_AUTOSUGGEST + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
};
exports.getProductsByAutoSuggest = getProductsByAutoSuggest;
const getTrendingProductsBySearch = (params, tokenData) => {
  let apiEndPoint = _ApiConst.TRENDING_PRODUCTS_BY_SEARCH;
  if (params && params.zone) {
    apiEndPoint += `&zone=${params.zone}`;
  }
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getTrendingProductsBySearch = getTrendingProductsBySearch;
const getCommonProductCarouselApiBySearch = (params, tokenData) => {
  let apiEndPoint = _ApiConst.TOP_DEALS_PRODUCTS_BY_SEARCH;
  if (params && params.zone) {
    apiEndPoint += `&zone=${params.zone}`;
  }
  if (params && params.offerType) {
    apiEndPoint += `&q=offerType%3A${params.offerType}`;
  }
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getCommonProductCarouselApiBySearch = getCommonProductCarouselApiBySearch;
const getEssentialProductsBySearch = (params, tokenData) => {
  let apiEndPoint = _ApiConst.ESSENTIAL_PRODUCTS_BY_SEARCH;
  if (params && params.zone) {
    apiEndPoint += `&zone=${params.zone}`;
  }
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getEssentialProductsBySearch = getEssentialProductsBySearch;
const getNewArrivalsProductsBySearch = (params, tokenData) => {
  let apiEndPoint = _ApiConst.NEW_ARRIVALS_PRODUCTS_BY_SEARCH;
  if (params && params.zone) {
    apiEndPoint += `&zone=${params.zone}`;
  }
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getNewArrivalsProductsBySearch = getNewArrivalsProductsBySearch;
const getBestSellerProductsBySearch = (params, tokenData) => {
  let apiEndPoint = _ApiConst.BEST_SELLER_PRODUCTS_BY_SEARCH;
  if (params && params.zone) {
    apiEndPoint += `&zone=${params.zone}`;
  }
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getBestSellerProductsBySearch = getBestSellerProductsBySearch;
const getREProductsForCarousel = (params, tokenData) => {
  const apiEndPoint = _ApiConst.RE_SEARCH_PRODUCTS + (0, _utils.getQuery)(params);
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getREProductsForCarousel = getREProductsForCarousel;
const getProductsFromCommonCarousel = (params, tokenData) => {
  const apiEndPoint = (0, _utils.buildUrl)(_ApiConst.RE_COMMON_CAROUSEL_PRODUCTS, params);
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getProductsFromCommonCarousel = getProductsFromCommonCarousel;
const getFBTProductsBySearch = (params, tokenData) => {
  let apiEndPoint = _ApiConst.FBT_PRODUCTS_BY_SEARCH;
  if (params && params.zone) {
    apiEndPoint += `?zone=${params.zone}`;
  }
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.POST;
  options.body = params.skuIds;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getFBTProductsBySearch = getFBTProductsBySearch;
const hitNotifyAPI = (params, tokenData) => {
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = {
    ...params,
    eventType: 'PRODUCT'
  };
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint: _ApiConst.NOTIFY_ME,
    options
  });
};
exports.hitNotifyAPI = hitNotifyAPI;
const hitNotifyDownloadAppLinkAPI = (requestParams, tokenData) => {
  const query = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = _ApiConst.NOTIFY_DOWNLOAD_APP_LINK + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.hitNotifyDownloadAppLinkAPI = hitNotifyDownloadAppLinkAPI;